import {Component, Input, OnInit} from '@angular/core';
import {ServiceTypeEnum} from '../models/cartDetails/service-type.enum';
import {SlotTypeEnum} from '../models/cartDetails/slot-type.enum';
import {
  IPrice,
  IPriceCycle,
  IPriceCycleInstallment,
  IPriceGroup,
  ISummaryInstallmentPricesList,
  OfferLegalInfoList
} from '../interfaces/cart-details.interface';
import {RechargingDeclination} from '../utils/pipes/rechargingDeclination';
import {CommonInfoService} from '../cart-process/common-info.service';
import {PriceFormatPipe} from '../utils/pipes/price-format.pipe';
import {MonthForm} from '../utils/pipes/monthForm';
import DateFormatPipe from '../utils/pipes/date-format.pipe';
import {PromotionTypeEnum} from '../models/cartDetails/promotionType.model';
import SlotModel from '../models/slot.model';
import {SectionTypeEnum} from '../models/cartDetails/section-type.enum';


@Component({
  selector: 'step-prices-component',
  templateUrl: './step-prices.component.html',
})
export default class StepPricesComponent implements OnInit {
  @Input() useOldTemplate = false;
  @Input() slot: SlotModel;
  @Input() slotType: SlotTypeEnum;
  @Input() sectionType: SectionTypeEnum;
  @Input() priceGroupItemName?: string;
  @Input() showMonthly = false;
  @Input() isMonthly = false;
  @Input() prices: IPriceCycle[];
  @Input() devicePrices: ISummaryInstallmentPricesList[];
  @Input() isAddonPrice: boolean;
  @Input() installmentPrice: IPriceCycleInstallment[];
  @Input() termOfServiceNumber: number;
  @Input() deviceTermLength?: number;
  @Input() serviceType: ServiceTypeEnum;
  @Input() promotionType: PromotionTypeEnum;
  @Input() ordinalNumber: number;
  @Input() forIndex: number;
  @Input('tooltip') tooltipContent: string;
  @Input() priceTooltip: OfferLegalInfoList;
  @Input() discount: string;
  @Input() hasDevice: boolean;
  @Input() isSideOrderSummary = false;
  @Input() isRetentionBeforeEOP: boolean;
  @Input() isOnlyRegularOffer: boolean;
  @Input() showOldPrice = false;
  @Input() isOfferWithDevice: boolean;
  @Input() priceType: string;
  @Input() isDeviceOnSummaryView: boolean;

  public showMonthlyIfOneStep: boolean;
  public showMonthlyIfOneStepText = '';
  public pricesList: IPriceCycle[] = [];
  public texts: string[] = [];
  public automationId = '';
  public isTooltipVisible = false;
  public ifOfferHasNoDevice: boolean;
  public ifOfferHasDevice: boolean;
  public isPostponedInstallments = false;
  public isFirstPage = false;
  public isBohoSideOrderSummary = false;
  public isMixOffer: boolean;
  public translateTooltip = false;
  public isVirginBrand = false;
  public isOrderSummary: boolean;
  private priceFormat: PriceFormatPipe = new PriceFormatPipe();
  private rechargingDeclination: RechargingDeclination = new RechargingDeclination();
  private monthFormDeclination: MonthForm = new MonthForm();
  private dateFormat: DateFormatPipe = new DateFormatPipe();
  private isB2C: boolean;

  constructor(
    protected commonInfoService: CommonInfoService
  ) {
  }

  ngOnInit(): void {
    const isGeneralSlotType: boolean = (this.sectionType === SectionTypeEnum.SIDEBAR || this.slotType === SlotTypeEnum.MEMBER || this.slotType === SlotTypeEnum.DATA || this.slotType === SlotTypeEnum.DEVICE);
    this.isVirginBrand = this.commonInfoService.isVirginBrand;
    this.ifOfferHasNoDevice = (!this.hasDevice && isGeneralSlotType);
    this.ifOfferHasDevice = (this.hasDevice && isGeneralSlotType);
    this.isFirstPage = this.commonInfoService.isFirstPage;
    this.isBohoSideOrderSummary = this.commonInfoService.isBohoOffer && this.isSideOrderSummary;
    this.isOrderSummary = this.slotType === 'summary';
    this.isMixOffer = this.commonInfoService.isServiceTypeMix;
    this.isB2C = this.commonInfoService.b2c;

    if (isGeneralSlotType) {
      this.automationId = this.slotType + '-' + this.ordinalNumber + '-offer-period-';
    } else if (this.slotType === SlotTypeEnum.ADDON) {
      this.automationId = 'member-' + this.ordinalNumber + '-addon-' + this.forIndex + '-offer-period-';
    } else if (this.slotType === SlotTypeEnum.MODAL) {
      this.automationId = this.slotType + '-offer-period-';
    } else if (this.slotType === SlotTypeEnum.SUMMARY) {
      this.automationId = this.slotType + '-offer-period-';
    }

    if (!this.tooltipContent && !this.isDeviceSlot) {
      this.translateTooltip = true;
      this.tooltipContent = this.isB2C ? 'tooltipText.subscription' : 'tooltipText.subscriptionB2B';
    }

    if (this.isMixOffer) {
      const lastPrice: IPriceCycle = this.prices[this.prices.length - 1];

      if (lastPrice.cycleEnd === 0) {
        lastPrice.cycleEnd = this.termOfServiceNumber;
      }
    }

    if (this.isFlexOffer) {
      this.pricesList = this.isDeviceSlot ? this.installmentPrice : this.prices;
    }

    if (this.isFlexOffer && this.isDeviceSlot) {
      this.checkPostponedInstallments();

      this.translateTooltip = true;
      this.tooltipContent = 'tooltipText.installments';
    }

    // false on device installmentPrice - now it's used only on summary page, probably this can be removed
    this.showMonthlyIfOneStep = this.prices?.length === 1 && !(this.installmentPrice && this.installmentPrice[0]) && this.showMonthly;


    if (this.isRetentionGroupOffer) {
      this.texts = [
        'pierwszy',
        'drugi',
        'trzeci',
        'czwarty',
        'piąty',
        'szósty',
        'siódmy',
        'ósmy',
        'dzesiąty',
        'jedenasty',
        'dwunasty'
      ];
    } else if (this.isMixOffer && this.slotType !== SlotTypeEnum.ADDON) {
      this.texts = [
        'pierwsze',
        '',
        'doładowań',
        'kolejne',
        'doładowań',
        ''
      ];

      const oneStepText = this.prices[0].cycleEnd + ' ' + this.getCycleEndText(this.prices[0].cycleEnd);
      this.showMonthlyIfOneStepText = `<b>${oneStepText}</b>`;
    } else {
      this.texts = [
        'miesięcznie',
        'do',
        'miesiąca',
        'od',
        'mies.',
        '/ mies.'
      ];

      if (this.showMonthly) {
        this.showMonthlyIfOneStepText = this.discount ? 'miesięcznie po rabatach' : 'miesięcznie';
      }
    }
  }

  public getCycleStartText(cycleNumber: number): string {
    if (this.isMixOffer) {
      return this.rechargingDeclination.transform(cycleNumber);
    }
  }

  public getCycleEndText(cycleNumber: number): string {
    if (this.isMixOffer) {
      return this.rechargingDeclination.transform(cycleNumber);
    }

    return this.texts[2];
  }

  getCycleEnd(cycleEnd: number): string {
    if (cycleEnd === 0) {
      return '';
    } else if (cycleEnd === 1) {
      return 'pierwszy miesiąc';
    } else {
      return `pierwsze ${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}`;
    }
  }

  getCycleEndEOP(cycleEnd: number, isStartDate: boolean): string {
    if (cycleEnd === 0) {
      return '';
    } else if (cycleEnd === 1 && !isStartDate) {
      return 'pierwszy miesiąc';
    } else if (!isStartDate) {
      return `pierwsze <b>${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b>`;
    } else {
      return `<b>${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b>`;
    }
  }

  public getCycleStartNumber(startNumber: number, endNumber: number): number {
    if (this.isMixOffer) {
      if (endNumber >= startNumber) {
        return endNumber - startNumber + 1;
      }

      return startNumber - 1;
    }

    return startNumber;
  }

  public getRetentionText({cycleStart, cycleEnd, endDate, startDate}: IPriceCycle): string {
    if (endDate) {
      return `do <b>${this.dateFormat.transform(endDate)}</b>`;
    } else if (startDate) {
      return `później <b>przez ${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b>`;
    } else {
      if (!cycleStart) return '';

      if (cycleEnd === 0 && this.prices.length > 1) {
        if (this.priceGroupItemName === 'installments') {
          cycleEnd = this.deviceTermLength;
        } else {
          cycleEnd = this.termOfServiceNumber;
        }
      }

      if (cycleStart === 1 && this.prices.length === 1) {
         if (cycleEnd === -1 && this.slotType === 'addon' &&  this.sectionType === 'sidebar') {
          return '';
        } else if (cycleEnd === 0) {
          return '';
        } else if (cycleEnd === 1) {
          return 'pierwszy miesiąc';
        } else {
          return `przez <b>${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b>`;
        }
      } else if (cycleStart === cycleEnd) {
        return this.isRetentionBeforeEOP ? `${this.texts[cycleStart - 1]} miesiąc` : `<b>${this.texts[cycleStart - 1]} miesiąc</b>`;
      } else {
        return this.isRetentionBeforeEOP
          ? `później <b>przez ${cycleEnd} <br> ${this.monthFormDeclination.transform(cycleEnd)}</b>`
          : `<b> od ${cycleStart} do ${cycleEnd} miesiąca</b>`;
      }
    }
  }

  public getFlexText({cycleStart, cycleEnd, startDate, endDate}: IPriceCycle, isRange?: boolean, isFirst?: boolean, offerChangePrices?: IPriceGroup, priceList?: IPriceCycle[]): string {
    if (!cycleEnd || cycleEnd < 1) {
      if (this.slotType === SlotTypeEnum.DEVICE) {
        cycleEnd = this.deviceTermLength;
      } else {
        cycleEnd = this.termOfServiceNumber;
      }
    }

    const prices = priceList ? priceList : this.pricesList;

    if (isRange) {
      if (cycleEnd < 0) {
        return 'miesiąca';
      } else {
        return !this.isRetentionBeforeEOP ?
        `${this.texts[1]}&nbsp;${cycleEnd}${this.slotType !== SlotTypeEnum.SUMMARY && this.isOfferWithDevice
        ? '<br class="br">' : ''} miesiąca`
        : `później&nbsp;<strong>przez ${cycleEnd} ${this.slotType !== SlotTypeEnum.SUMMARY
          ? '<br class="br">'
          : ''} ${this.monthFormDeclination.transform(cycleEnd)}</strong>`;
      }
    } else if (startDate && isFirst && (!!this.slot?.offerChangePrices?.subsidy?.length || !!offerChangePrices?.subsidy?.length)) {
      return `<span><b>od ${this.dateFormat.transform(startDate)}</b></span><br><span>przez <b> ${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b></span> `;
    } else if (this.slotType === SlotTypeEnum.SUMMARY && isFirst && endDate) {
      return `<span> do </span> <b> ${this.dateFormat.transform(endDate)}</b>`;
    } else if (this.slotType === SlotTypeEnum.SUMMARY && !isFirst && this.isRetentionBeforeEOP) {
      return endDate
      ? `<span><span> później </span> <b>do ${this.dateFormat.transform(endDate)}</b></span>`
      : prices.length > 2
        ? `<span>później</span>`
        : `<span>później <b>przez ${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b></span>`;
    } else if (this.isDeviceOnSummaryView && this.slotType === SlotTypeEnum.DEVICE && this.isRetentionBeforeEOP) {
      return `przez ${prices.length > 1 ? 'pierwsze' : ''}<b> ${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b>`;
    } else if (isFirst && prices.length > 1) {
      return cycleEnd > 1
        ? `pierwsze <b> ${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b>`
        : 'pierwszy <b>miesiąc</b>';
    } else if (cycleEnd > 1) {
      return `przez <b> ${cycleEnd} ${this.monthFormDeclination.transform(cycleEnd)}</b>`;
    }
  }

  public getPrice(price: IPrice): string | undefined {
    return price ? price[this.commonInfoService.taxName] : undefined;
  }

  public getOldPrice(priceList: IPriceCycle[]): string | undefined {
    return this.getPrice(priceList[0].oldPrice);
  }

  public getInstallmentPrice(indexNumber: number): string | undefined {
    if (
      this.installmentPrice?.length
      && this.installmentPrice[indexNumber]
    ) {
      const fullPrice: string = this.priceFormat.transform(this.installmentPrice[indexNumber].price[this.commonInfoService.taxName]);
      const priceEnding = this.commonInfoService.b2c ? 'zł' : 'zł VAT 0%';

      return `${fullPrice} ${priceEnding}`;
    }

    return undefined;
  }

  public checkPostponedInstallments(): void {
    if (this.installmentPrice) {
      this.installmentPrice.find(item => this.isPostponedInstallments = !!item.postponedInstallments);
    }
  }

  public get isRetentionGroupOffer(): boolean {
    return this.commonInfoService.isRetentionOffer &&
      (this.slotType === SlotTypeEnum.SUMMARY || this.isMemberSlot || this.sectionType === SectionTypeEnum.SIDEBAR);
  }

  public get isFlexOffer(): boolean {
    return this.promotionType === PromotionTypeEnum.INSTALLMENT_FLEX;
  }

  public get isFlexDeviceOffer(): boolean {
    return this.isFlexOffer && this.isDeviceSlot;
  }

  public get isMemberSlot(): boolean {
    return this.slotType === SlotTypeEnum.MEMBER;
  }

  public get isDeviceSlot(): boolean {
    return this.slotType === SlotTypeEnum.DEVICE;
  }

  public get isFlexAddonOffer(): boolean {
    return this.isFlexOffer && this.slotType === SlotTypeEnum.ADDON;
  }

  public isPriceDiscount(price: IPriceCycle): boolean {
    return price.oldPrice && this.sectionType === 'slot' ? parseInt(price.price.gross) > 0 : true;
  }
}
